import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ArticleSection from './components/ArticleSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://pandabuy.blog';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: `${SITE_URL}/`,
      name: 'Pandabuyspreadsheet Hub',
      description: 'The ultimate curated hub for pandabuy spreadsheet finds, verified product links, and trending haul discoveries updated daily.',
      publisher: {
        '@type': 'Organization',
        '@id': `${SITE_URL}/#organization`,
        name: 'Pandabuy Blog',
        url: `${SITE_URL}/`,
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/#webpage`,
      url: `${SITE_URL}/`,
      name: 'Pandabuyspreadsheet – The Ultimate Pandabuy Spreadsheet Hub 2026',
      description: 'Discover the best pandabuyspreadsheet collections with verified finds, trending haul spreadsheets, and curated fashion categories. Your go-to SEO hub for pandabuy spreadsheet discoveries updated daily.',
      isPartOf: { '@id': `${SITE_URL}/#website` },
      about: { '@id': `${SITE_URL}/#organization` },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://readdy.ai/api/search-image?query=High-end%20streetwear%20collection%20flat%20lay%20with%20designer%20sneakers%20premium%20hoodies%20and%20luxury%20accessories%20arranged%20on%20warm%20marble%20surface%20editorial%20fashion%20photography%20soft%20golden%20lighting%20warm%20beige%20tones%20clean%20minimalist%20composition%20high%20detail%20product%20showcase&width=1800&height=900&seq=hero-streetwear-v2-2026&orientation=landscape',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <ArticleSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}